import React from 'react'

import { AdminContext } from 'contexts/AdminContext'

import { ZariContext } from '_zari/context'

import { Portlet, Alert } from '_zari/core'

import { MovimientosTurnoModal } from 'sharedComponents/modals'

import { IdGen } from 'utils'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'

import * as GuiasVentaService from 'services/guiasVenta.service'

import * as Vistas from './vistas'

const NuevoIngresoGuiaPage = ({ match }) => {
  const __adminContext = React.useContext(AdminContext)
  const __zariContext = React.useContext(ZariContext)

  const [__keyMainForm, setKeyMainForm] = React.useState(null)
  const [mostrarMovimientosTurnoModal, setMostrarMovimientosTurnoModal] = React.useState(false)

  const editarDataRef = React.useRef({})

  const portletBreadcrumbs = React.useMemo(() => {
    if (match.params.id) {
      return [{ name: 'Guias Ventas', path: `/${CodigosTransaccionesConstant.VENTASINGRESOGUIA_LISTA}` }, { name: 'Editar' }]
    }
    return [{ name: 'Guias Ventas', path: `/${CodigosTransaccionesConstant.VENTASINGRESOGUIA_LISTA}` }, { name: 'Nuevo' }]
  }, [match.params.id])

  const clickMovimientosTurno = React.useCallback(() => {
    setMostrarMovimientosTurnoModal(true)
  }, [])

  const portletButtons = React.useMemo(() => {
    if (__adminContext.valoresConfiguracionUsuario.flagAtencionIsla) {
      return [{ name: 'Movimientos del Turno', onClick: clickMovimientosTurno }]
    }
    return []
  }, [__adminContext.valoresConfiguracionUsuario.flagAtencionIsla, clickMovimientosTurno])

  React.useEffect(() => {
    if (match.params.id) {
      GuiasVentaService.getGuia(match.params.id)
        .then(({ data }) => {
          editarDataRef.current = data
          setKeyMainForm(IdGen.newId())
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    } else {
      setKeyMainForm(IdGen.newId())
    }
  }, [match.params, __zariContext])

  return (
    <>
      {__adminContext.estadoTurno ? (
        <Portlet>
          <Portlet.Header title='Guias Ventas' breadcrumbs={portletBreadcrumbs} buttons={portletButtons} />
          <Portlet.Body>
            {__keyMainForm && (
              <>
                {__adminContext.valoresConfiguracionUsuario.flagAtencionIsla ? (
                  <Vistas.GrifoVista
                    key={__keyMainForm}
                    editarData={editarDataRef.current}
                    reiniciarFormulario={() => setKeyMainForm(IdGen.newId())}
                  />
                ) : (
                  <Vistas.EstandarVista key={__keyMainForm} editarData={editarDataRef.current} />
                )}
              </>
            )
            // <NuevaMainForm key={__keyMainForm} editarData={editarDataRef.current} />
            }
          </Portlet.Body>
        </Portlet>
      ) : (
        <Alert color='danger'>Esta función requiere aperturar turno.</Alert>
      )}
      {mostrarMovimientosTurnoModal && (
        <MovimientosTurnoModal
          show={mostrarMovimientosTurnoModal}
          handleClose={() => {
            setMostrarMovimientosTurnoModal(false)
          }}
          self
        />
      )}
    </>
  )
}

export default NuevoIngresoGuiaPage
